import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_POWER_STATIONS,
    FETCH_POWER_STATIONS_FAILURE,
    FETCH_POWER_STATIONS_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    powerStations: {
        data: { columns: [], data: [], pagination: {} },
        errors: null,
        isFetching: false,
    },
};

const powerStationsSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_POWER_STATIONS]: (state) => {
            state.powerStations.isFetching = true;
            state.powerStations.errors = null;
        },
        [FETCH_POWER_STATIONS_FAILURE]: (state, action) => {
            state.powerStations.data.data = [];
            state.powerStations.errors = action.payload;
            state.powerStations.isFetching = false;
        },
        [FETCH_POWER_STATIONS_SUCCESS]: (state, action) => {
            state.powerStations.data = action.payload;
            state.powerStations.isFetching = false;
        },
    },
});

export const powerStationsActions = powerStationsSlice.actions;

export default powerStationsSlice.reducer;
